// recon-helpers-messages (en catalog).
window.PlummeI18n.register('en', {
  'rcx.loan.class.accruedInterest': 'Accrued interest',
  'rcx.loan.class.unbookedPrincipal': 'Unbooked repayment',
  'rcx.loan.class.unbookedFee': 'Unbooked fee',
  'rcx.loan.class.timing': 'Timing difference',
  'rcx.loan.class.fxDifference': 'Currency difference',
  'rcx.loan.class.wrongLedger': 'Wrong ledger account',
  'rcx.loan.class.wrongTerm': 'Wrong short-term/long-term classification',
  'rcx.loan.class.missingDocs': 'Missing documentation',
  'rcx.loan.class.other': 'Other',
});
